module.exports = __webpack_public_path__ + "img/01.854a50b3.jpg";